<mat-form-field appearance="outline">
    <mat-label>{{ label() }} </mat-label>
    @if (prefixIcon()) {
    <mat-icon matPrefix>{{prefixIcon()}}</mat-icon>
    }
    <div style="display: flex; flex-direction: row;">
        <input matInput [formControl]="internalControl" [matAutocomplete]="auto" (input)="onInput($event)"
            (blur)="onBlur($event)" (keydown.enter)="onEnter($event)" style="width: 100%" />
        <div style="display: inline-flex; gap: 3px; margin-right: 10px">
            @if (internalControl.value?.icons?.length) {
            @for(i of internalControl.value.icons; track i) {
            @if ( i==='archive') {
            <span matSuffix class="material-symbols-outlined" style="color: var(--nexus-purple)" matTooltip="archived">{{i}}</span>
            } @else {
            <span matSuffix class="material-symbols-outlined">{{i}}</span>
            }
            }
            }
            @if (showLink()) {
            <a [attr.href]="(internalControl.value?.id ? (internalControl.value.id | urlMaker : linkItem()) : null)"
                [class.n-disabled-link]="!internalControl.value?.id" [class.n-enabled-link]="internalControl.value?.id"
                target="_blank">
                <span matSuffix class="material-symbols-outlined">open_in_new</span></a>
            }
        </div>
    </div>
    @if (hint()) {
    <mat-hint>{{ hint() }}</mat-hint>
    }
    <mat-autocomplete #auto="matAutocomplete" [requireSelection]="requireSelection" [displayWith]="displayFn"
        (optionSelected)="handleSelect($event.option.value)">
        @for (opt of filteredOptions(); track opt.id) {
        <mat-option [value]="opt" (mousedown)="onOptionMouseDown()">
            <span style="display: inline-flex; flex-direction: row; gap:5px; align-items: center;">
                {{ opt | optionLabel:displayAlternateName() }}
                @if (opt.icons.length) {
                @for(i of opt.icons; track i) {
                @if ( i==='archive') {
            <span matSuffix class="material-symbols-outlined" style="color: var(--nexus-purple)" matTooltip="archived">{{i}}</span>
                } @else {
                <span matSuffix class="material-symbols-outlined">{{i}}</span>
                } }
                }
            </span>
        </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>